import { render } from "./productsColorSummary.vue?vue&type=template&id=6d2ac2ee"
import script from "./productsColorSummary.vue?vue&type=script&lang=js"
export * from "./productsColorSummary.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__